import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type PaymentInstructionActionVariant = 'cancelSuccess' | 'cancelError' | 'handledError';

const VARIANT_CONFIG: Record<
  PaymentInstructionActionVariant,
  {key: string; iconName: 'sollapay:check' | 'sollapay:close'}
> = {
  cancelSuccess: {key: 'cancelPayment.success', iconName: 'sollapay:check'},
  cancelError: {key: 'cancelPayment.error', iconName: 'sollapay:close'},
  handledError: {key: 'handledPayment.error', iconName: 'sollapay:close'}
};

type Props = {
  toastId: string | number;
  variant: PaymentInstructionActionVariant;
};

export const PaymentInstructionActionToast: FC<Props> = ({toastId, variant}) => {
  const {t} = useTranslation('trustAccounts');
  const {key, iconName} = VARIANT_CONFIG[variant];

  return (
    <ToastCard
      iconName={iconName}
      title={t(`view.buyers.detail.${key}.title`)}
      description={t(`view.buyers.detail.${key}.description`)}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.buyers.detail.toastClose')}
    />
  );
};

export function showPaymentInstructionActionToast(variant: PaymentInstructionActionVariant): void {
  toast.custom(id => <PaymentInstructionActionToast toastId={id} variant={variant} />, {
    duration: 10_000
  });
}
